export const TopSectionHeader = 'Property Sales Management'
export const projectName = localStorage.getItem('projectName')
